const { api } = require("data/api");

const searchApi = api.injectEndpoints({
  endpoints: builder => ({
    searchBookings: builder.query({
      query: ({ guestEmail }) => ({
        url: "/airbox/search/bookings",
        method: "GET",
        params: { guest_email: guestEmail }
      }),
      transformResponse: response => response?.bookings
    }),
    searchProperties: builder.query({
      query: ({ homeCode }) => ({
        url: "/airbox/search",
        method: "GET",
        params: { home_code: homeCode }
      }),
      transformResponse: response => response?.property
    })
  })
});

export const { useSearchBookingsQuery, useSearchPropertiesQuery } = searchApi;
